import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: params => ({
        start_date: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
        end_date:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY),
        host:       params.host,
        severity:   params.severity,
        ordering:   params.sort,
        state:      'all',
        page:       params.page,
        page_size:  params.pageSize,
        donwload:   params.download,
        operable:   params.operable
    }),
    ...storeModuleFactory({
        name:               'monitoringAlarms',
        endpoint:           endpoints.monitoring.alarms,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            ...response,
            results: response.results.map(event => ({
                createdDate: event.created_date * TIMESTAMP_MULTIPLY,
                closedDate:  event.closed_date * TIMESTAMP_MULTIPLY,
                object:      event.obj,
                objectClass: event.obj_class,
                severity:    event.severity,
                nodeName:    event.ci_name,
                description: event.subject,
                msOperable:  event.ms_operable
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/monitoringAlarms.js